module.exports = __webpack_public_path__ + "static/media/forest.de2e6f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/forest.png
// module id = 551
// module chunks = 0